import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAnimation } from '../../context/AnimationContext';
import usePageSEO from '../../hooks/usePageSEO';
import { getPageSEO, HOTEL_JSONLD } from '../../config/seoConfig';
import HomeCard from './HomeCard';
import ReasonGridItem from './ReasonGridItem';
import ContactModal from '../ContactModal/ContactModal';
import '../css/LuxuryHome.css';
import '../../App.css'; 
import luxuryVideo from '../../assets2/V9 CAPILLA CUARTOS.mp4'; 
import whatsIcon from '../../assets2/whats.webp';

import imgCarr1 from '../../assets2/1 FRONT PAGE/CARRUSEL FRONT PAGE/1.webp';
import imgCarr3 from '../../assets2/1 FRONT PAGE/CARRUSEL FRONT PAGE/3.webp';
import imgCarr4 from '../../assets2/1 FRONT PAGE/CARRUSEL FRONT PAGE/4.webp';
import imgCarr5 from '../../assets2/1 FRONT PAGE/CARRUSEL FRONT PAGE/5.webp';
import imgCarr6 from '../../assets2/1 FRONT PAGE/CARRUSEL FRONT PAGE/6.webp';
import imgCarr7 from '../../assets2/1 FRONT PAGE/CARRUSEL FRONT PAGE/7.webp';
import imgCarr8 from '../../assets2/1 FRONT PAGE/CARRUSEL FRONT PAGE/8.webp';
import imgCarr9 from '../../assets2/1 FRONT PAGE/CARRUSEL FRONT PAGE/9.webp';
import imgCarr10 from '../../assets2/1 FRONT PAGE/CARRUSEL FRONT PAGE/10.webp';

import imgB1 from '../../assets2/1 FRONT PAGE/CARRUSEL BODAS/1.webp';
import imgB2 from '../../assets2/1 FRONT PAGE/CARRUSEL BODAS/2.webp';
import imgB3 from '../../assets2/1 FRONT PAGE/CARRUSEL BODAS/3.webp';
import imgB4 from '../../assets2/1 FRONT PAGE/CARRUSEL BODAS/4.webp';
import imgB5 from '../../assets2/1 FRONT PAGE/CARRUSEL BODAS/5.webp';
import imgB6 from '../../assets2/1 FRONT PAGE/CARRUSEL BODAS/6.webp';
import imgB7 from '../../assets2/1 FRONT PAGE/CARRUSEL BODAS/7.webp';
import imgB8 from '../../assets2/1 FRONT PAGE/CARRUSEL BODAS/8.webp';

import imgRecorridos from '../../assets2/EXTRA/IMG_3023-min-2-scaled.webp';
import imgAlberca from '../../assets2/EXTRA/ALBERCA/2.webp';
import imgRutaVino from '../../assets2/1 FRONT PAGE/RUTA DEL VINO.webp';
import imgFirePit from '../../assets2/IMAGENES/La Capilla Horizontal 3.webp';

import bgBoutique from '../../assets2/CarruselBoutique/3.webp';
import bgCasa from '../../assets2/4.webp';

import footerImg from '../../assets2/La-Capialla-Hotel-Vector-scaled.webp';

import iconServicio from '../../assets2/iconossvg/Recurso-23.svg';
import iconTaxi from '../../assets2/iconossvg/Recurso-17.svg';
import iconAeropuerto from '../../assets2/iconossvg/Recurso-19-1.svg';
import iconTransporte from '../../assets2/iconossvg/Recurso-18.svg';

const images = [imgCarr1, imgCarr3, imgCarr4, imgCarr5, imgCarr6, imgCarr7, imgCarr8, imgCarr9, imgCarr10];
const bodaImgs = [imgB1, imgB2, imgB3, imgB4, imgB5, imgB6, imgB7, imgB8];

const LuxuryCarousel = () => {
  const { animationsPaused } = useAnimation(); 
  const [isHovered, setIsHovered] = useState(false);
  const { t } = useTranslation();

  const shouldPause = animationsPaused || isHovered;

  return (
    <section className="luxury-carousel-section">
      <div className="intro-section-luxury">
       <div className="luxury-text-top">
  <h2 dangerouslySetInnerHTML={{ __html: t('home.introCarousel') }} />
</div>
      </div>
      <div 
        className="luxury-carousel-wrapper"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div 
          className="luxury-carousel-track"
          style={{ 
            animationPlayState: shouldPause ? 'paused' : 'running' 
          }}
        >
          {images.map((src, index) => (
            <div key={index} className={`luxury-slide slide-${index + 1}`}>
              <img 
                src={src} 
                alt={`Suite ${index + 1}`}
                loading="lazy"
                decoding="async"
              />
            </div>
          ))}
          {images.map((src, index) => (
            <div key={`dup-${index}`} className={`luxury-slide slide-${index + 1}`}>
              <img 
                src={src} 
                alt={`Suite ${index + 1}`}
                loading="lazy"
                decoding="async"
              />
            </div>
          ))}
        </div>
      </div>
      <br />
      <p className="section-subtitle-intro separation">
        <strong>{t('home.introSubtitle')}</strong>
      </p>
    </section>
  );
};

const BodaCarousel = () => {
  const { animationsPaused } = useAnimation(); 
  const [isHovered, setIsHovered] = useState(false);
  const { t } = useTranslation();

  const shouldPause = animationsPaused || isHovered;

  return (
    <section className="luxury-carousel-section">
      <div className="section-header-intro">
        <h2 className="section-title-intro">
          {t('home.weddingCarouselTitle')}
        </h2>
      </div>
      <div 
        className="luxury-carousel-wrapper"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div 
          className="luxury-carousel-track"
          style={{ 
            animationPlayState: shouldPause ? 'paused' : 'running' 
          }}
        >
          {bodaImgs.map((src, index) => (
            <div key={index} className={`luxury-slide slide-${index + 1}`}>
              <img 
                src={src} 
                alt={`Suite ${index + 1}`}
                loading="lazy"
                decoding="async"
              />
            </div>
          ))}
          {bodaImgs.map((src, index) => (
            <div key={`dup-${index}`} className={`luxury-slide slide-${index + 1}`}>
              <img 
                src={src} 
                alt={`Suite ${index + 1}`}
                loading="lazy"
                decoding="async"
              />
            </div>
          ))}
        </div>
      </div>
      <p className="section-subtitle-intro">
        <strong>{t('home.weddingCarouselSubtitle')}</strong>
      </p>
    </section>
  );
};

function LuxuryHome() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const seo = getPageSEO(i18n.language, 'home');
  usePageSEO({ ...seo, path: '/', lang: i18n.language, jsonLd: HOTEL_JSONLD });
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [contactData, setContactData] = useState({ label: '', number: '' });

  useEffect(() => {
    setLoaded(true);
    
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavigate = (path) => {
    navigate(path);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleContactChoice = (number, label, e) => {
    e.preventDefault();
    setContactData({ label, number });
    setContactModalOpen(true);
  };

  const handleCallClick = () => {
    window.location.href = `tel:${contactData.number}`;
    setContactModalOpen(false);
  };

  const handleCopyClick = () => {
    const text = contactData.number;
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text)
        .then(() => {
          setContactModalOpen(false);
          alert(t('footer.copied', { number: text }));
        })
        .catch(() => alert(t('footer.copyError')));
    } else {
      const el = document.createElement('textarea');
      el.value = text;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      try { document.execCommand('copy'); setContactModalOpen(false); alert(t('footer.copied', { number: text })); } catch { alert(t('footer.copyError')); }
      document.body.removeChild(el);
    }
  };

  const getFormattedDate = (date) => date.toISOString().slice(0, 10);
  const [checkIn, setCheckIn] = useState(getFormattedDate(new Date()));
  const [checkOut, setCheckOut] = useState(getFormattedDate(new Date(Date.now() + 86400000)));
  const [adults, setAdults] = useState(2);
  const [children, setChildren] = useState(0);
  const [showHotelChoice, setShowHotelChoice] = useState(false);

  const handleHomeSearch = (e) => {
    e.preventDefault();
    setShowHotelChoice(true);
  };

  const handleHotelChoice = (hotel) => {
    const path = hotel === 'boutique' ? '/habitaciones-boutique' : '/habitaciones-disponibles';
    const query = new URLSearchParams({
      checkIn,
      checkOut,
      adults: String(adults),
      children: String(children)
    }).toString();
    setShowHotelChoice(false);
    navigate(`${path}?${query}`);
  };

  return (
    <div className={`App ${loaded ? 'loaded' : ''}`}>
      
      {/* Sección 1: Video Hero */}
      <header className="separation">
        <section className="video-hero-luxury">
          <video 
            autoPlay 
            loop 
            muted 
            playsInline
            preload="metadata"
            className="video-background-luxury"
            src={luxuryVideo} 
          >
          </video>
          <div className="hero-overlay-luxury"></div>
          
          <div className="hero-content-luxury-home">          
            <div className="luxury-brand-header-home">
              <div className="brand-ornament-home top"></div>
              <h1 className="luxury-hotel-name-home">{t('home.heroTitle')}</h1>
              <div className="brand-subtitle-home">{t('home.heroBrand')}</div>
              <div className="brand-ornament-home bottom"></div>
            </div>
          </div>
        </section>
      </header>

      {/* Barra de búsqueda — anclada al borde inferior de la pantalla */}
      <div className="home-search-panel">
        <form className="home-search-form" onSubmit={handleHomeSearch}>
          <div className="home-search-row">
            <label>
              Check-in
              <input
                type="date"
                value={checkIn}
                min={getFormattedDate(new Date())}
                onChange={(event) => setCheckIn(event.target.value)}
                required
              />
            </label>
            <label>
              Check-out
              <input
                type="date"
                value={checkOut}
                min={checkIn || getFormattedDate(new Date(Date.now() + 86400000))}
                onChange={(event) => setCheckOut(event.target.value)}
                required
              />
            </label>
          </div>
          <div className="home-search-row">
            <label>
              Adultos
              <input
                type="number"
                min="1"
                max="5"
                value={adults}
                onChange={(event) => setAdults(event.target.value)}
                required
              />
            </label>
            <label>
              Niños
              <input
                type="number"
                min="0"
                max="4"
                value={children}
                onChange={(event) => setChildren(event.target.value)}
              />
            </label>
            <button type="submit" className="home-search-button">
              Buscar disponibilidad
            </button>
          </div>
        </form>
      </div>

      {showHotelChoice && (
        <div className="hotel-choice-overlay">
          <div className="hotel-choice-card">
            <div className="hotel-choice-inner">
              <p className="hotel-choice-title">¿En qué hotel quieres buscar?</p>
              <div className="hotel-choice-actions">
                <button type="button" className="hotel-choice-btn primary" onClick={() => handleHotelChoice('casaHotel')}>
                  Casa Hotel
                </button>
                <button type="button" className="hotel-choice-btn secondary" onClick={() => handleHotelChoice('boutique')}>
                  Boutique
                </button>
              </div>
            </div>
            <button type="button" className="hotel-choice-close" onClick={() => setShowHotelChoice(false)}>
              Cerrar
            </button>
          </div>
        </div>
      )}

      <LuxuryCarousel />

      <main className="luxury-main-home">

        <section className="events-section-luxury" style={{paddingTop: '120px'}}>
          <p className='events-description' style={{fontSize: '28px'}}> {t('home.introDesc1')}</p>
          <br />
          <p className='events-description' style={{fontSize: '20px'}}>{t('home.introDesc2')}</p>
        </section>

        <section className="navigation-cards-section-new">
          
          <div className="card-section-header">
            <h2 className="card-section-title">
              {t('home.chooseTitle')}
            </h2>
          </div>
          
          <div className="cards-grid-new-luxury">
            <HomeCard
              title={t('home.boutiqueTitle')}
              description={t('home.boutiqueDesc')}
              imageURL={bgBoutique}
              onClick={() => handleNavigate('/boutique')} 
            />
            <HomeCard
              title={t('home.casaTitle')}
              description={t('home.casaDesc')}
              imageURL={bgCasa}
              onClick={() => handleNavigate('/reservas')}
            />
          </div>
        </section>
        <br />
        <br />
        <br />
        <br />

        <BodaCarousel />

        <section className="events-section-luxury" style={{paddingTop: '120px'}}>
          <p className="events-description">
            {t('home.eventsDesc')}
          </p>
          <p className="events-subtitle">
            {t('home.eventsSubtitle')}
          </p>
          <button 
            className="events-cta-btn"
            onClick={() => handleNavigate('/bodas')}
          >
            {t('home.eventsBtn')}
          </button>
        </section>
        
        <section className="reasons-section-luxury">
          <div className="reasons-header">
            <h2 className="reasons-title" dangerouslySetInnerHTML={{ __html: t('home.reasonsTitle') }} />
            <p className="reasons-subtitle">
              {t('home.reasonsSubtitle')}
            </p>
          </div>

          <div className="reasons-grid">
            <ReasonGridItem title={t('home.reason1')} imageURL={imgRecorridos} />
            <ReasonGridItem title={t('home.reason2')} imageURL={imgAlberca} />
            <ReasonGridItem title={t('home.reason3')} imageURL={imgRutaVino} />
            <ReasonGridItem title={t('home.reason4')} imageURL={imgFirePit} />
          </div>
        </section>
        
        <section className="services-section">
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">
                <img src={iconTransporte} alt="Ícono de Autobús" className="service-icon-img" /> 
              </div>
              <h3>{t('home.serviceTransport')}</h3>
              <p>{t('home.serviceTransportDesc')}</p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <img src={iconTaxi} alt="Ícono de Taxi/Uber" className="service-icon-img" /> 
              </div>
              <h3>{t('home.serviceTaxi')}</h3>
              <p>{t('home.serviceTaxiDesc')}</p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <img src={iconAeropuerto} alt="Ícono de Aeropuerto" className="service-icon-img" /> 
              </div>
              <h3>{t('home.serviceAirport')}</h3>
              <p>{t('home.serviceAirportDesc')}</p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <img src={iconServicio} alt="Ícono de Equipaje/Transporte" className="service-icon-img" /> 
              </div>
              <h3>{t('home.serviceCapilla')}</h3>
              <p>{t('home.serviceCapillaDesc')}</p>
            </div>
          </div>
        </section>
      </main>

      <footer className="luxury-footer">
        <div className="footer-content-luxury">
          
          <div className="footer-left">
            <div className="footer-brand">
              <div className="footer-logo-image">
                <img src={footerImg} alt="La Capilla Hotel Logo" className="luxury-logo" />
              </div>
            </div>
            
            <div className="footer-contact-list">
              <a href="https://wa.me/524777347474" className="footer-contact-item">
                <span className="contact-icon">
                  <img 
                    src={whatsIcon} 
                    alt="WhatsApp" 
                    style={{ width: '20px', height: '20px', verticalAlign: 'middle' }} 
                  />
                </span>
                <span>{t('footer.whatsapp')}</span>
              </a>
              <a href="#" className="footer-contact-item" onClick={(e) => handleContactChoice('+524181789398', 'Lobby', e)}>
                <span className="contact-icon" style={{ color: '#000' }}>✆</span>
                <span>{t('footer.lobby')}</span>
              </a>
              <a href="#" className="footer-contact-item" onClick={(e) => handleContactChoice('+524181324886', 'Bodas', e)}>
                <span className="contact-icon" style={{ color: '#000' }}>✆</span>
                <span>{t('footer.bodas')}</span>
              </a>
              <a href="mailto:lacapillasl@gmail.com" className="footer-contact-item">
                <span className="contact-icon" style={{ color: '#000' }}>✉️</span>
                <span>{t('footer.email')}</span>
              </a>
            </div>
          </div>
          
          <div className="map-container-large">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3721.528157656598!2d-100.85089992496557!3d21.131369580543762!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x842b396ed04be78f%3A0x762e7b72784e7cc5!2sLa%20Capilla%20Hotel!5e0!3m2!1ses-419!2smx!4v1762517651261!5m2!1ses-419!2smx"
              width="100%"
              height="100%"
              style={{border:0}}
              allowFullScreen=""
              loading="lazy"
              title="La Capilla Hotel Location"
            ></iframe>
          </div>    
        </div>
        
        <div className="footer-bottom-luxury">
          <p>{t('footer.copyright')}</p>
        </div>
      </footer>

      {showScrollTop && (
        <button className="luxury-scroll-top" onClick={scrollToTop}>
          <span className="scroll-icon">↑</span>
        </button>
      )}

      <ContactModal
        isOpen={contactModalOpen}
        label={contactData.label}
        number={contactData.number}
        onCall={handleCallClick}
        onCopy={handleCopyClick}
        onClose={() => setContactModalOpen(false)}
      />
    </div>
  );
}

export default LuxuryHome;